<template>
  <div id="app">
    <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
      <nav-menu />
      <div class="main-panel">
        <top-navbar></top-navbar>
        <div class="panel-header panel-header-sm"> </div>
        <div :class="{content: !$route.meta.hideContent}" @click="toggleSidebar">
          <zoom-center-transition :duration="200" mode="out-in">
            <!-- your content here -->
            <div class="main__block">
              <router-view></router-view>
            </div>
          </zoom-center-transition>
        </div>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'

import TopNavbar from './components/TopNavbar.vue'
import Menu from './components/Menu'
import ContentFooter from './components/ContentFooter.vue'
import { SlideYDownTransition, ZoomCenterTransition } from 'vue2-transitions'

function hasElement (className) {
  return document.getElementsByClassName(className).length > 0
}

function initScrollbar (className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`)
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className)
    }, 100)
  }
}

export default {
  components: {
    TopNavbar,
    'nav-menu': Menu,
    ContentFooter,
    SlideYDownTransition,
    ZoomCenterTransition
  },
  methods: {
    toggleSidebar () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    }
  },
  mounted () {
    let docClasses = document.body.classList
    let isWindows = navigator.platform.startsWith('Win')
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar('sidebar')
      initScrollbar('sidebar-wrapper')

      docClasses.add('perfect-scrollbar-on')
    } else {
      docClasses.add('perfect-scrollbar-off')
    }
  }
}
</script>
